import React from "react"
import { ReferenceField, ReferenceFieldProps, TextField } from "react-admin"

export const EntryStatusRefField: React.FC<Partial<ReferenceFieldProps>> = (props) => (
  <ReferenceField
    {...props}
    source="entry_status_id"
    reference="entry_statuses"
    link="show"
    label="Status"
  >
    <TextField source="status" />
  </ReferenceField>
)
